import { createApiCall } from 'lib/base';

const CREATE_WEALTH_PROGRAM = 'WEALTH/CREATE_WEALTH_PROGRAM';

const apiCall = createApiCall(
  CREATE_WEALTH_PROGRAM,
  ({ payload }: { payload: any }) => ({
    endpoint: `/api/admin/wealth/programs`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);

export default apiCall;
